import React from 'react';

const OrderDeliveryDesktop = ({ delivery }) => {
  const fullAddress = [
    delivery.street,
    delivery.buildingNumber,
    delivery.flatNumber ? `кв. ${delivery.flatNumber}` : null,
  ]
    .filter(Boolean)
    .join(', ');

  if (!delivery) return null;

  return (
    <div className="card">
      <h5 className="card-header font-weight-bold">
        🚚 Доставка
      </h5>

      <div className="card-body">
        <div><strong>Тип:</strong> {delivery.deliveryDescription}</div>
        <div><strong>Отримувач:</strong> {delivery.name} {delivery.surname}</div>
        <div><strong>Телефон:</strong> {delivery.phone}</div>

        {delivery.departmentNumber && (
          <>
            <div><strong>Місто:</strong> {delivery.city}</div>
            <div><strong>Відділення:</strong> {delivery.departmentNumber}</div>
          </>
        )}

        {!delivery.departmentNumber && fullAddress && (
          <>
            <div><strong>Місто:</strong> {delivery.city}</div>
            <div>
              <strong>Адреса:</strong> {fullAddress}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OrderDeliveryDesktop;